/* eslint-disable global-require */

export default {
  data() {
    return {
      /* CLUSTERS */
      gridSize: 50,
      showClusters: true,

      clusterstyles: [
        {
          url: require('@/assets/img/content/map/markers/heart-icon-small.png'),
          height: 27,
          width: 30,
          anchor: [4, 0],
          textColor: 'white',
          textSize: 10,
          backgroundPosition: '',
        },
        {
          url: require('@/assets/img/content/map/markers/heart-icon-medium.png'),
          height: 36,
          width: 40,
          anchor: [8, 0],
          textColor: 'white',
          textSize: 11,
          backgroundPosition: '',
        },
        {
          url: require('@/assets/img/content/map/markers/heart-icon-large.png'),
          width: 50,
          height: 45,
          anchor: [12, 0],
          textColor: 'white',
          textSize: 12,
          backgroundPosition: '',
        },
      ],
    };
  },
};
